import { useMutation } from 'react-query';
import { ProjectMilestonesApi } from '../../../api/ProjectApi/ProjectMilestonesApi';
import { useInvalidateProjectMilestones } from './useProjectMilestones';

export const useMilestoneGoalEdit = () => {
  const invalidateMilestones = useInvalidateProjectMilestones();

  return useMutation(ProjectMilestonesApi.patchProjectMilestoneGoal, {
    onSuccess: (_, input) => {
      invalidateMilestones(input.projectUid);
    },
  });
};
